module.exports = __webpack_public_path__ + "media/bangkok/twin_temple-37e97865.jpg";